import { ObstetricalExamResultState } from "@/Patient/Models/ObstetricalFile/ObstetricalExamResultState";

class OntarioObstetricalExamAsIndicated {
    public HeadAndNeckExamState: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public AbdomenExamState: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public BreastNipplesExamState: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public HeartLungsExamState: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public MusculoskeletalExamState: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public PelvicExamState: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public OtherExamState: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;

    constructor(fields?: Partial<OntarioObstetricalExamAsIndicated>) {
        Object.assign(this, fields);
    }

    public setEmptyExamsAsNormal(): void {
        this.HeadAndNeckExamState ||= ObstetricalExamResultState.Normal;
        this.AbdomenExamState ||= ObstetricalExamResultState.Normal;
        this.BreastNipplesExamState ||= ObstetricalExamResultState.Normal;
        this.HeartLungsExamState ||= ObstetricalExamResultState.Normal;
        this.MusculoskeletalExamState ||= ObstetricalExamResultState.Normal;
        this.PelvicExamState ||= ObstetricalExamResultState.Normal;
        this.OtherExamState ||= ObstetricalExamResultState.Normal;
    }
}

export { OntarioObstetricalExamAsIndicated };
